import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ch-down",
  "use": "icon-ch-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevrons-down\" id=\"icon-ch-down\"><polyline points=\"7 13 12 18 17 13\" /><polyline points=\"7 6 12 11 17 6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol